module.exports = __webpack_public_path__ + "img/generally_gray.1a59f6ba.png";